var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',{attrs:{"name":"code_registration","title":"регистрация кода"},on:{"closeModal":_vm.closeModal},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('CodeRegForm')]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }